import React from 'react';
import TableActionButton from './TableActionButton';
import { Eye, Pencil, Download, Plus, Trash2, FileText, Phone, UserCheck, UserX, Check, X as CloseIcon } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

export const ActionView = ({ onClick, title = "View Details", disabled = false }) => (
  <TableActionButton icon={Eye} onClick={onClick} title={title} variant="primary" disabled={disabled} />
);

export const ActionEdit = ({ onClick, title = "Update", disabled = false }) => (
  <TableActionButton icon={Pencil} onClick={onClick} title={title} variant="orange" disabled={disabled} />
);

export const ActionDownload = ({ onClick, title = "Download", disabled = false }) => (
  <TableActionButton icon={Download} onClick={onClick} title={title} variant="success" disabled={disabled} />
);

export const ActionAdd = ({ onClick, title = "Add / Start", disabled = false }) => (
  <TableActionButton icon={Plus} onClick={onClick} title={title} variant="primary" disabled={disabled} />
);

export const ActionDelete = ({ onClick, title = "Delete", disabled = false }) => (
  <TableActionButton icon={Trash2} onClick={onClick} title={title} variant="danger" disabled={disabled} />
);

export const ActionDocument = ({ onClick, title = "View Document", disabled = false }) => (
  <TableActionButton icon={FileText} onClick={onClick} title={title} variant="primary" disabled={disabled} />
);

export const ActionCall = ({ onClick, title = "Call / Copy Number", disabled = false }) => (
  <TableActionButton icon={Phone} onClick={onClick} title={title} variant="call" disabled={disabled} />
);

export const ActionToggle = ({ onClick, isActive = true, title = isActive ? "Deactivate Account" : "Activate Account", disabled = false }) => (
  <TableActionButton icon={isActive ? UserX : UserCheck} onClick={onClick} title={title} variant={isActive ? "danger" : "success"} disabled={disabled} />
);

export const ActionApprove = ({ onClick, title = "Approve", disabled = false }) => (
  <TableActionButton icon={Check} onClick={onClick} title={title} variant="success" disabled={disabled} />
);

export const ActionReject = ({ onClick, title = "Reject", disabled = false }) => (
  <TableActionButton icon={CloseIcon} onClick={onClick} title={title} variant="danger" disabled={disabled} />
);

export const ActionWhatsapp = ({ onClick, title = "WhatsApp", disabled = false }) => (
  <TableActionButton icon={FaWhatsapp} onClick={onClick} title={title} variant="whatsapp" disabled={disabled} />
);
